import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class CareerRoutesDetailAboutVacancyBlock extends BaseModel {
  static override constructorName = 'CareerRoutesDetailAboutVacancyBlock'

  profession: string = ''
  link: string = ''
  name: string = ''
  slug: string = ''
  image: string = ''
  url: string = ''
  'vacancies_count': number = 0
  salary: number = 0
  'internships_count': number = 0
  cities: number = 0
  'regions_total': number = 0
  'workplaces_total': number = 0
  'vacancies_max_amount': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.image = toCroppedImage(this.image)
    }
  }
}
